import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './FAQPreview.css';

const FAQPreview = ({ onNavigate }) => {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const faqRef = ref(database, 'faq');
    const unsubscribe = onValue(faqRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setFaqs(list);
      } else {
        setFaqs([]);
      }
    });
    return () => unsubscribe();
  }, []);

  const displayFaqs = faqs.slice(0, 3);

  if (faqs.length === 0) return null;

  return (
    <section id="sss" className="faq-preview">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Sıkça Sorulan Sorular</h2>
          <p className="section-subtitle">Merak ettiklerinizin yanıtları</p>
        </div>
        <div className="faq-preview-list">
          {displayFaqs.map((item) => (
            <div
              key={item.id}
              className={`faq-preview-item ${openId === item.id ? 'open' : ''}`}
            >
              <button
                type="button"
                className="faq-preview-question"
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
              >
                <span>{item.question}</span>
                <span className="faq-preview-icon">{openId === item.id ? '−' : '+'}</span>
              </button>
              <div className="faq-preview-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
        {onNavigate && (
          <div className="faq-preview-cta">
            <button type="button" className="view-all-btn" onClick={() => onNavigate('faq')}>
              Tümünü görüntüle
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQPreview;
